import { Injectable } from "@angular/core";
import { HttpService } from "../../utils/services/http.service";
import { Observable } from "rxjs/Observable";
import { ErrorsService } from "../../utils/services/errors.service";

@Injectable()
export class EmployeesService {
  constructor(
    private httpService: HttpService,
    private errorsService: ErrorsService
  ) {}

  /*Get employee details and filtered based on page size*/
  getEmployeesDetails(pageNumber, status,totalEmployees,startDate,endDate): Observable<any> {
    const data = {
      pageSize: 15,
      pageNumber: pageNumber,
      status: status,
      totalEmployees:totalEmployees,
      startDate:startDate,
      endDate:endDate
    };
    return this.httpService
      .post(`employee/listFilter`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  getEmployeesDetailsForExport(status,totalEmployees): Observable<any> {
    const data = {
      status: status,
      totalEmployees:totalEmployees
    };
    return this.httpService
      .post(`employee/listFilter`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /*Search employee for from employee list*/
  searchFilter(searchTerm: string, status): Observable<any> {
    const data = {
      searchText: searchTerm,
      status: status,
      totalEmployees:"true"
    };
    return this.httpService
      .post(`employee/listFilter`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /*Function to delete employee*/
  deleteEmployee(employee: string, data: any): Observable<any> {
    return this.httpService
      .delete(`employee/${employee}/${data.Empname}/${data.EmailID}`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /*Function to update employee*/
  updateEmployee(data): Observable<any> {
    return this.httpService
      .put(`employee`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /*Function to get RM list*/
  getrmList(): Observable<any> {
    const data = {
      role: "RM",
    };
    return this.httpService
      .post(`delegation/listemployees`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /*Function to reset employee password*/
  resetPwd(employee): Observable<any> {
    const data = {
      role: employee.Role,
      empno: employee.employeeId,
    };
    return this.httpService
      .post(`resetPwd`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /*Function to handle observable errors*/
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/employees/employees.service.ts